export function MarkdownContent({ content }: { content: string }) {
  const lines = content.split("\n");
  return (
    <div className="markdown-content">
      {lines.map((line, index) => {
        if (line.startsWith("## ")) return <h3 key={index}>{line.slice(3)}</h3>;
        if (line.startsWith("- ")) return <li key={index}>{line.slice(2)}</li>;
        if (!line.trim()) return <div className="markdown-spacer" key={index} />;
        return <p key={index}>{line}</p>;
      })}
    </div>
  );
}

